/* istanbul ignore file */
// eslint-disable-next-line simple-import-sort/imports
import '../scripts/wdyr';
import React from 'react';
import { setLocaleCookies } from '@noths/polaris-client-localisation';
import { CookieModal } from '@noths/polaris-client-gdpr-compliance';
import { GTM } from '@noths/polaris-client-google-analytics';
import type { BaseAppProps } from '@noths/polaris-client-next-components';
import { BaseApp } from '@noths/polaris-client-next-components';
import { SkipLinks, useSmartAppBanner } from '@noths/polaris-client-site-chrome-ui';
import type { AppContextPlusCookies } from '@noths/polaris-dev-ts-types';
import type { AppInitialProps, AppProps } from 'next/app';
import NextApp from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';

import { fetchGlobalContent } from 'src/services/contentstack';
import { SKIP_CONTENT_TARGET_ID } from '../constants/elementIds';
import { getFeatureFlagsWithMatchers } from '../utils/getFeatureFlagsWithMatchers';
import { isProd } from '../environment';

const config = getConfig();
const AppComponent = BaseApp(config);

const App = (props: AppProps & BaseAppProps) => {
  useSmartAppBanner();

  return (
    <>
      <Head>
        <CookieModal useTestScript={!isProd()} />
      </Head>
      <SkipLinks links={[{ content: 'Skip to content', sectionId: SKIP_CONTENT_TARGET_ID }]} />
      <GTM />
      <AppComponent {...props} />
    </>
  );
};

App.getInitialProps = async (
  appContext: AppContextPlusCookies,
): Promise<AppInitialProps & BaseAppProps> => {
  const {
    router,
    ctx: { req, res },
  } = appContext;

  if (req && res) {
    setLocaleCookies({ req, res });
  }

  const featureFlags = (req && getFeatureFlagsWithMatchers(req)) || {};
  const appProps = await NextApp.getInitialProps(appContext);

  if (router.route === '/404') {
    const [navData] = await fetchGlobalContent({ featureFlags });

    return {
      ...appProps,
      navData,
      featureFlags,
    };
  }

  return { ...appProps, featureFlags };
};

export default App;
